import { Injectable } from '@angular/core';
import { APP_CONFIG } from '../../app.config';
import {
  Translation,
  TranslationField,
  TranslationLang,
  TranslationType,
} from '../models/translation.model';
import { Language } from '../enums/languages.enum';
import { RequestService } from './request.service';

@Injectable()
export class LanguageService {
  constructor(private requestService: RequestService) {}

  async getTranslations(originalId: number, type: TranslationType): Promise<Translation[]> {
    const urlRequest: string = `${APP_CONFIG.WEBSERVICE.TRANSLATION}?type=${type}&originalId=${originalId}`;
    return await this.requestService.getData(urlRequest);
  }

  async saveTranslations(translation: Translation): Promise<void> {
    return await this.requestService.postData(APP_CONFIG.WEBSERVICE.TRANSLATION, translation);
  }

  async getAutoTranslation(
    text: string,
    source: Language,
    target: Language
  ): Promise<{ text: string }> {
    let params: any = {
      text: text,
      source: source,
      target: target,
    };
    return await this.requestService.postData(APP_CONFIG.WEBSERVICE.AUTO_TRANSLATION, params);
  }

  prepareTranslationToShow(
    translation: Translation,
    field: TranslationField,
    originalId: number,
    storeId: number,
    type: TranslationType,
    defaultValue?: string
  ): Translation {
    if (!translation) {
      translation = {} as Translation;
      translation.field = field;
    }
    if (storeId) {
      translation.storeId = storeId;
    }
    translation.originalId = originalId; // pode ser nulo se estiver criando uma nova entidade
    translation.type = type;

    if (!translation.translations) {
      translation.translations = [];
    }
    if (!translation.translations.find((t) => t.default)) {
      translation.translations.unshift(
        new TranslationLang({ value: defaultValue || '', default: true })
      );
    }
    return translation;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/language.service.ts